import { Dialog } from "primereact/dialog";
import * as client from "../../../client";

type ReconciliationFunctionModalProps = {
  visible: boolean;
  setVisible: (value: boolean) => void;
  sovs: client.Sov[];
};

export const ReconciliationFunctionModal: React.FC<
  ReconciliationFunctionModalProps
> = ({ visible, setVisible, sovs }) => {
  const sovsWithFunction = sovs.filter(
    (sov) => sov.reconciliation_function && sov.is_enabled
  );

  return (
    <Dialog
      header="TIV Reconciliation Functions"
      visible={visible}
      style={{ width: "700px", maxHeight: "80vh" }}
      onHide={() => setVisible(false)}
    >
      {sovsWithFunction.length === 0 ? (
        <p>No reconciliation functions were used for any enabled SOV.</p>
      ) : (
        sovsWithFunction.map((sov) => (
          <div key={sov.sov_id} style={{ marginBottom: "16px" }}>
            <h4 style={{ margin: "0 0 8px 0" }}>{sov.filename}</h4>
            <pre
              style={{
                backgroundColor: "var(--surface-ground)",
                padding: "12px",
                borderRadius: "6px",
                overflow: "auto",
                maxHeight: "400px",
                fontSize: "0.85rem",
                lineHeight: "1.4",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {sov.reconciliation_function}
            </pre>
          </div>
        ))
      )}
    </Dialog>
  );
};
